import React, { Component } from 'react';
import { Link } from 'react-router-dom';


class AddDPP extends Component {
  constructor(props) {
    super(props);
    this.screen = '';
    this.state = {
      success: false,
      processing:false,
      error:false,
      person: ''
    }; 
  }
  
  componentDidMount() {
  }

  componentDidUpdate(){
  }

async submit(ev) {
        ev.preventDefault();
        this.setState({processing:true})
         let join={}
        join.senderName = ev.target.senderName.value;
        join.senderEmail = ev.target.senderEmail.value;
        join.businessName = ev.target.businessName.value;
        join.address = ev.target.address.value;
        join.city = ev.target.city.value;
        join.state = ev.target.state.value;
        join.website = ev.target.website.value;
        join.phone = ev.target.phone.value;
        join.businessEmail = ev.target.businessEmail.value;
        join.zip = ev.target.zip.value;
       
    
       console.log(join) 

        let response = await fetch(`/api/wsde-submit`, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({join})
          }).catch(err=>{
            console.log(err)
          })
          if (response.status === 200){
            this.setState({success:true,proccessing:false, person:`${join.senderName}`},()=>{
              const form = document.getElementById('wsde-form')
              const formHold = document.getElementById('addWSDEformHold')
              if(formHold){
                formHold.scrollTo(0,0)
              }   
              if(form){
                form.reset();
              }
              
            })
      
          }
          else if(response.status === 404){
            this.setState({error:true})
        
          }
    
      }

  render() {
    // const {} = this.state;
  
    return (
      <React.Fragment>
        <div id="addWSDEformHold" className="relative">
          {this.state.success?(
            <div className="thanksStage absolute centeredContent bgRed wT centerT">
               <h2 className="fullStage centeredContent">{`Thank you for the heads up \n ${this.state.person}`}</h2>
            </div>
          ):('')}
            
          <div className="formIntro tfStage blkT">
            <h3 className="upperT">We invite any and all anticapitalist institution builders to suggest new Dual Power practices, enterprises, and projects.</h3>
            <p>Before submitting a new entry, however, please start with the basic criteria below to assess whether or not it aligns with our core principles and objectives as a socialist organization moving within a much larger (global) movement:</p>
            <p>This practice, enterprise, or project is:</p>
            <ul>
              <li>dedicated to a revolutionary vision of the economy and society as a whole that prioritizes people and planet above competition, growth, and profit.</li>
              <li>dedicated to the principles of democracy, cooperation, mutualism, and, ultimately, socialism.</li>
              <li>dedicated to building against (and dismantling) all social systems of domination and oppression in all areas, including race, class, gender, etc.</li>
              <li>dedicated to direct, participatory democracy in which ownership and governance is controlled by members and/or workers, as well as the communities in which various practices, enterprises, or projects sit.</li>
              <li>dedicated to sustainability and strives to operate in a fashion that respects our ecological system (eco-socialist).</li>
            </ul>
            <p>If you hit the mark on everything above, feel free to move on to the submission form! Our folks will review as soon as we can and reach out if there are any specific questions.</p>
            <p>If you were not able to check off all of the above, then we still invite you to fill out the suggestion form as a potential “ally.” Your submission may not get the same priority, but we will process it nevertheless and get back to you with any questions.</p>
          </div>
          <form id="wsde-form" className="tfStage" onSubmit={this.submit.bind(this)}>
            <input className="formItem resourceAuthor required relative" name="businessName" type="text" placeholder="BUSINESS NAME" required></input>
            <input className="formItem resourceAuthor required relative" name="address" type="text" placeholder="STREET ADDRESS" required></input>
            <input className="formItem resourceAuthor required relative" name="city" type="text" placeholder="CITY" required></input>
            <input className="formItem resourceAuthor required relative" name="state" type="text" placeholder="STATE" required></input>
            <input className="formItem resourceAuthor required relative" name="zip" type="text" placeholder="ZIPCODE" required></input>
            <input className="formItem resourceAuthor relative" name="website" type="text" placeholder="WEBSITE"></input>
            <input className="formItem resourceAuthor relative" name="phone" type="phone" placeholder="PHONE"></input>
            <input className="formItem resourceAuthor relative" name="businessEmail" type="email" placeholder="EMAIL"></input>
            <input className="formItem resourceAuthor required relative" name="senderName" type="text" placeholder="YOUR NAME" required></input>
            <input className="formItem resourceAuthor required relative" name="senderEmail" type="email" placeholder="YOUR EMAIL" required></input>
            <input className="buttonCTA formButton upperT boldT" type="submit" value='Send'></input>
          </form>
        </div>
      </React.Fragment>
    )
  }
}
  
export default AddDPP;


// WEBPACK FOOTER //
// ./src/components/strategy/wsde/asdf.js